// extracted by mini-css-extract-plugin
export default {"container":"Content_container__mPuX5","text":"Content_text__Oq1eG","input":"Content_input__tjqik"};